const lang = {
    xzdq:'選擇地區',
    db:'阿聯酋',
    db1:'杜拜',
    tg:'台股',
    rg:'日股',
    azg:'澳洲股',
    mlxyg:'馬來西亞股',
    xjp_g:'新加坡股',
    m_g:'美股',
    d_g:'德股',
    gzjq:'市場假期',
    xgsc:'香港',
    xgscs:'香港',
    mgsc:'美國',
    mgscs:'美國',
    china:'中國',
    chinas:'中國',
    xjp:'新加坡',
    xjps:'新加坡',
    ja:'日本',
    az:'澳洲',
    tw:'台灣',
    dg:'德國',
    ml:'馬來西亞',
    china_c:'中國',
    xjp_c:'新加坡',
    ja_c:'日本',
    az_c:'澳洲',
    tw_c:'台灣',
    ml_c:'馬來西亞',
    xg:'香港',
    am:'美國',
    grzh:'個人帳戶',
    gszh:'公司帳戶',
    wtlb:'問題類別',
    sswt:'搜索問題',
    yhmc:'銀行名稱',
    zhhm:'帳戶號碼 / 貨幣種類',
    swif:'銀行代碼',
    addre:'分行地址',
    zhmc:'帳戶名稱',
    xggp:'香港證券',
    scjs:'市場介紹',
    jyfs:'交易須知',
    fwsf:'服務收費',
    jytg:'交易通告',
    jytgs:'最新通告',
    gstg:'公司通告',
    jtzb:'集團總部',
    lxwm:'聯繫我們',
    ybcx:'一般查詢',
    jyrx:'交易熱線',
    mfndzx:'免費內地專線',
    cz:'傳真',
    dy:'電郵',
    bgsj:'辦公時間',
    dtime:'上午9:00 -下午6:00 星期六、星期日及香港公眾假期休息',
    zcgl:'資產管理',
    glfw:'管理服務',
    tzcl:'投資策略',
    qmiswx:'華亞金融集團官方微信',
    homes:'首頁 / 環球股票',
    b_fimg:require('@/image/home/alld.png'),
    getimage:require('@/image/home/getimage.png'),
    hongd_img:require('@/image/honggu/downimg.png'),
    rq_date:'日期',
    rq_biaoti:'通告',
    hongd_img_model:require('@/image/home_model/downimg.png'),
    getimagemodel:require('@/image/home_model/getimage.png'),
    mzsm:'免責聲明',
    qmisyeas:'版權所有 2021 華亞金融集團保留擁有權',
    agree:'同意',
    an_ree:'不同意',
    Android:require('@/image/home/Android_cn.png'),
    Android_s:require('@/image/home_s/Android_cn.png'),
    mod_and:require('@/image/home_model/Android.png'),
    inSearch:'搜索',
    isBack:'返回上頁',
    jjfw:'基金服務',
    jjcp:'基金產品',
    mggp:'美國股票',
    xgrg:'新股認購',
    xgrl:'新股日曆',
    xjpg:'新加坡股',
    malxy:'馬來西亞股',
    aozg:'澳洲股',
    jagu:'日股',
    twstk:'台股',
    slgt:'滬深港通',
    zqfw:'債券服務',
    gpzc:'股票轉倉',
    klzh:'開立帳戶',
    tckx:'款項提存',
    qlkh:'證券交易',
    ydkh:'郵遞開戶',
    yykh:'預約開戶',
    zxkh:'在線開戶',
    wskh:'網上開戶',
    sjfw:'數據服務',
    zjcq:'資金存取',
    bgxz:'表格下載',
    SecuritiesTrading:'證券交易',
    AssetManagement:'資產管理',
    cjwt:'常見問題',
    cn_login:'登入交易平台',
    nYeat:' 年',
    ystk:'私隱政策',
    fxpl:'風險披露聲明',
    tkxz:'條款及細則',
    clj:'超連結政策',
    aqts:'安全提示及建議',
    grsm:'收集個人資料聲明',
    ywjj:'業務簡介',
    cpfw:'產品及服務',
    zsw:'暫時沒有結果符合您的搜索條件“',
    cxss:'”，請重新搜索。',
    ssjy:'以下是一些搜索建議',
    y1:'請檢查是否所有內容均輸入正確',
    y2:'嘗試更改常用的字詞或減少查詢字詞的數量',
    y3:'嘗試改用其他關鍵字或使用近義詞',
    alb:'按類別搜索',
    Alert:'澄清啟事',
    bew:'偽冒華亞金融集團名稱及公司商標進行違法和欺詐推銷',
    ithas:'華亞金融集團 （QMIS FINANCIAL GROUP） （「本集團」）近日得悉有騙徒偽冒本集團透過電話及 / 或即時通訊軟件（例如 WhatsApp及微信等社交媒介），訛稱本集團進行招募工作，以賺取佣金作為利誘，誘騙受害人提供個人資料及存入金錢。',
    ithas1:'本集團茲澄清，上述之違法和欺詐推廣活動，一概與本集團及本集團旗下任何附屬公司（包括但不限於華亞證券有限公司及華亞資產管理有限公司）無關。本集團謹此呼籲各位切勿在任何情況下向第三者支付任何款項及 / 或透露任何敏感的個人及/或帳戶信息，請小心保護個人資料。',
    ithas2:'如懷疑受騙或需要協助，敬請立即前往警署報案或致電香港警務處反詐騙協調中心「防騙易」熱線18222查詢。',
    ithas3:'特此澄清',
    qgp:'華亞金融集團 啟',
    dapas:'二零二二年三月十一日',
    yuedu:'已閱讀',

    zgdl: "中國",
    zgxg: "中國香港",
    zgam: "中國澳門",
    adly: "澳大利亞",
    jnd: "加拿大",
    mlxy: "馬來西亞",
    mg: "美國",
    xjp1: "新加坡",
    xxl: "新西蘭",
    yg: "英國",

    title_1:'預約開立香港證券帳戶',
    title_2:'歡迎使用預約開戶服務，本行職員會於此申請表遞交後儘快致電您以確認會面詳情。如需協助，請於辦公時間內致電客戶服務熱線 (852) 3971 6919 或親臨本行查詢。',
    title_3:'個人資料',
    zwmc_yy:'中文名稱',
    cw_yy:'稱謂',
    dydz_yy:'電郵地址',
    lldh_yy:'聯絡電話',
    
    title_4:'預約詳情',
    yyrq_yy:'預約日期',
    yysj_yy:'預約時間',
    yzm_yy:'驗證碼',
    dj_yy:'遞交',


    jjlx:'基金類型：',
    jjjs:'基金介紹',
    jxrg:'進行認購',
    qbjjlb:'全部基金類別',
    hhzczj:'混合資產基金',
    jjzdzj:'基金中的基金',
    hbsczj:'貨幣市場基金',
    qhzj:'均衡基金',
    dxzj:'定息基金',
    gpzj:'股票基金',
    zszj:'指數基金',
    llzj:'另類基金',

    jjbh:'產品編號',
    jjmc:'產品名稱',
    jjhb:'貨幣',
    jjclr:'發行日期',
    ljbx:'累積表現',
    jjlb:'產品類別',
    fxpj:'風險評級',
    rg_buy:'認購',
    nodata:'暫沒有任何基金產品可供認購。',
    nodata1:'暫沒有任何債券產品可供認購。',


    zqlx:'債券類型：',
    gjbh:'產品編號',
    zqfxr:'產品名稱',
    zqhb:'貨幣',
    pxpl:'派息頻率',
    ndpx:'年度票息',
    zqlb:'產品類別',
    synq:'剩餘年期',

    zqjs:'債券介紹',
    zqcp:'債券產品',
    syzqlx:'所有債券類型',
    zqzq:'主權債券',
    qyzh:'企業債券',
    zzqzq:'準主權債券',
    jzdbzq:'資產擔保債券',
    gsyqyzq:'高收益企業債券',

    jjrg:'基金認購',
    zqrg:'債券認購',
    zqzh:'證券帳號',
    yhdh:'電話號碼',
    sbm:'識別碼',
    tj:'提 交',

    month_text:' 個月',
    months_text:' 個月',

    wt1:'請閣下選擇您的「年齡組別」:',
    wt2:'請閣下簡述您的「最高學歷」:',
    wt3:'請閣下簡述您的「總淨資產」:',
    wt4:'請閣下簡述您的「就業狀況」:',
    wt5:'閣下是否被歸類為',
    wt5_11:'「特定人士」',
    wt6:'請問閣下對「衍生及結構性投資產品」有否基本知識 ?',
    wt7:'請問閣下對「基金產品投資」有否相關經驗 ?',
    wt8:'請問閣下對「債券產品投資」有否相關經驗 ?',
    wt9:'閣下是否被歸類為',
    wt9_11:'「個人專業投資者」',
    
    wt1_1:'A. 18 至 24',
    wt1_2:'B. 25 至 39',
    wt1_3:'C. 40 至 54',
    wt1_4:'D. 55 至 64',
    wt1_5:'E. 65 或 以上',

    wt2_1:'A. 不適用',
    wt2_2:'B. 小學或以下',
    wt2_3:'C. 中學或專上學院',
    wt2_4:'D. 大學或以上 / 專業資格 (與財經學科相關)',
    wt2_5:'E. 大學或以上 / 專業資格 (與財經學科無關)',

    wt3_1:'A. 少於港幣 500,000',
    wt3_2:'B. 港幣 500,000 至 港幣 999,999',
    wt3_3:'C. 港幣 1,000,000 至 港幣 4,999,999',
    wt3_4:'D. 港幣 5,000,000 至 港幣 7,999,999',
    wt3_5:'E. 港幣 8,000,000 或 以上',

    wt4_1:'A. 自僱',
    wt4_2:'B. 全職',
    wt4_3:'C. 兼職',
    wt4_4:'D. 待業',
    wt4_5:'E. 退休',

    wt5_1:'A. 是',
    wt5_2:'B. 否',

    wt6_1:'A. 有',
    wt6_2:'B. 沒有',
    wt6_3:'閣下獲得基本知識的意思是 :',
    wt6_4:'A. 接受「衍生及結構性投資產品」培訓或修讀相關課程',
    wt6_5:'B. 現時的工作 或/及 以往的工作經驗與「衍生及結構性投資產品」有關',
    wt6_6:'C. 於過去3年內進行多於或等於 5 宗「衍生及結構性投資產品」交易次數所得',

    wt7_1:'A. 有',
    wt7_2:'B. 沒有',
    wt7_3:'如有，請問閣下有否曾經投資在以下的「基金類型」? (可選多於一項)',
    wt7_4:'A. 混合資產基金',
    wt7_5:'B. 基金中的基金',
    wt7_6:'C. 貨幣市場基金',
    wt7_7:'D. 均衡基金',
    wt7_8:'E. 定息基金',
    wt7_9:'F. 股票基金',
    wt7_10:'G. 指數基金',
    wt7_11:'H. 另類基金',
    wt7_12:'請閣下簡述您有關「基金產品」的投資經驗：',
    wt7_13:'A. 少於 1 年',
    wt7_14:'B. 1 年 至 3 年',
    wt7_15:'C. 3 年 至 8 年',
    wt7_16:'D. 多於 8 年',

    wt8_1:'A. 有',
    wt8_2:'B. 沒有',
    wt8_3:'如有，請問閣下有否曾經投資在以下的「債券類型」? (可選多於一項)',
    wt8_4:'A. 主權債券',
    wt8_5:'B. 企業債券',
    wt8_6:'C. 準主權債券',
    wt8_7:'D. 資產擔保債券',
    wt8_8:'E. 收益企業債券',
    wt8_9:'請閣下簡述您有關「債券產品」的投資經驗：',
    wt8_10:'A. 少於 1 年',
    wt8_11:'B. 1 年 至 3 年',
    wt8_12:'C. 3 年 至 8 年',
    wt8_13:'D. 多於 8 年',

    wt9_1:'A. 是',
    wt9_2:'B. 否',

    bz1:"備註 #1 :",
    bz1_1:"「特定人士」",
    bz1_2:"包括患有殘障並該殘障可能影響其投資決定的客戶 (例如 : 視障、聽障、語障、長期嚴重疾病等) / 長者 (66歲或以上) / 教育程度 (小學六年級或以下) / 財政能力有限。",

    bz2:"備註 #2 :",
    bz2_1:"「個人專業投資者」",
    bz2_2:"為個人或聯名帳戶，其擁有的投資組合在 (相關計算日子內) 擁有不少於港幣8百萬或等值外幣的投資組合",
    bz2_3:"(a) 該個人本人的帳戶內的投資組合；",
    bz2_4:"(b) 該個人聯同其有聯繫者於某聯權共有帳戶內的投資組合；",
    bz2_5:"(c) 該個人在聯同一名或多於一名其有聯繫者以外的人士於某聯權共有帳戶內的投資組合中所佔部份；或",
    bz2_6:"(d) 在有關日期的主要業務是持有投資項目並在有關日期由該個人全資擁有的法團的投資組合。",
    bz2_7:"某名個人在聯同一名或多於一名其有聯繫者以外的人士於某聯權共有帳户內的投資組合中所佔部份",
    bz2_8:"(a) 為帳戶持有人之間訂立的書面協議中指明，該個人於該投資組合中所佔部份；或",
    bz2_9:"(b) (如沒有訂立B (a) 段所述的協議)為於該投資組合中平均所佔部份。",

    next:"下一步",
    red_ts1:"請完成 ( 紅色提示 / 紅框 ) 部分",
    red_ts2:"如閣下是「投資基金客戶」，鑒於閣下未能被歸類為「個人專業投資者」，因此未能符合資格認購「基金投資產品」，問卷已經完成。",

    pj1:'保守型',
    pj1_1:'評級結果為「保守型」的客戶只適合投資於較低風險之金融投資產品。',
    pj1_2:'「保守型」客戶通常願意承受較低程度的投資風險及接受獲取較低的投資回報。與此同時，客戶必須明白產品投資價值有機會遠低於始初投資金額。「保守型」客戶在金融投資方面具備有限或毫無相關知識及/或經驗。',
    
    pj2:'穩健型',
    pj2_1:'評級結果為「穩健型」的客戶只適合投資於較低至中等風險之金融投資產品。',
    pj2_2:'「穩健型」客戶通常願意承受相比於低風險較為高的投資產品，藉以獲取較銀行存款利息高的回報以抗衡通脹。與此同時，客戶亦必須明白產品投資價值有機會遠低於始初投資金額。「穩健型」客戶通常具備一些金融投資相關知識及/或經驗。',

    pj3:'均衡型',
    pj3_1:'評級結果為「均衡型」的客戶只適合投資於中等風險之金融投資產品。',
    pj3_2:'「均衡型」客戶通常願意承受中度的投資風險以獲取媲美環球證券市場指數的投資回報。與此同時，客戶亦必須明白產品投資價值有機會遠低於始初投資金額。「均衡型」客戶通常具備合理的相關知識及/或經驗。',

    pj4:'增長型',
    pj4_1:'評級結果為「增長型」的客戶只適合投資於中等至高風險之金融投資產品。',
    pj4_2:'「增長型」客戶通常願意承受中至高度的投資風險以獲取高於媲美環球證券市場指數的投資回報。與此同時，客戶亦必須明白產品投資價值有機會遠低於始初投資金額。「增長型」客戶通常具備通常相當的金融投資知識及/或經驗，或/及具有健全的財政實力以承受中等至高風險的投資損失。',

    pj5:'進取型',
    pj5_1:'評級結果為「進取型」的客戶只適合投資於高等風險之金融投資產品。',
    pj5_2:'「進取型」客戶通常願意承受相當高度的投資風險以獲取明顯高於環球證券市場指數的投資回報。與此同時，客戶亦必須明白產品投資價值有機會遠低於始初投資金額。「進取型」客戶多數具備專門的投資知識及/或經驗，尤其高風險、複雜結構性或槓桿投資產品，及擁有健全及/或雄厚的財政實力可以承受高風險投資的損失。',

    
    title1:'投資取向問卷',
    title2:'更多評級',

    tj2_1:'投資取向分析結果',
    tj2_2:'閣下之「客戶投資取向問卷」結果為：',
    tj2_3:'選擇其它債券產品',
    tj2_4:'選擇其它基金產品',

    tj2_5:'返 回',
    tj2_6:'確 認',

    tj2_7:'客戶投資取向問卷',
    tj2_8:'我們已收到您的投資取向問卷',

    jjmz1:'注意事項及免責聲明',
    jjmz2:'注意事項',
    jjmz3:'投資基金產品涉及重大風險，投資者可能無法取回 ( 部份或全部 ) 最初投資之金額。本聲明不可能完全披露涉及閣下所投資基金產品的相關風險。在作出投資決策前，閣下請詳細閱讀有關投資基金產品的銷售文件，確保完全瞭解有關投資基金產品的性質及其相關所泛及的風險，及願意承擔這類型風險，並建議向獨立第三方索取專業的投資意見。\n\n在決定投資有關基金產品前，閣下必須詳細考慮根據閣下的公民身份、居住地或戶籍的國家/司法管轄區 ( 或閣下所屬公司所註冊成立國家/司法管轄區 ) 或會與購買、銷售、認購、持有、轉換或出售相關基金投資產品內持股有關在法律下，閣下 ( 或閣下所屬公司 ) 可能需要面對的稅務、法律規定以及任何外匯管制規定所連帶之後果。\n\n投資基金的回報以其基本貨幣計算。如閣下所屬國家/司法管轄區貨幣與其投資基金的基本貨幣或參考貨幣不同，匯率變動或會使閣下的投資回報有所增加或減少。',
    jjmz4:'免責聲明',
    jjmz5:'本應用程式所刊載的基金投資產品並非適用於所有國家/司法管轄區。只有適用法律容許之人士，才可瀏覽此應用程式的資訊及/或接受本免責聲明所提及的服務及投資產品。瀏覽此免責聲明的人士，必須確保其知悉及遵守有關的適用限制，及自行負責查證其所在國家/司法管轄區的法律是否容許其瀏覽本應用程式及/或使用有關服務。本應用程式所提供的資訊目的在提供給香港特別行政區的居民使用及/或瀏覽。\n\n本應用程式的基金投資產品資訊謹供一般性參考及全部以「如原狀」情況所提供。華亞證券不會對該等資料作出任何保證，另華亞證券可在毋須事前通知的情況下，隨時更改該等資料。\n\n本應用程式所提供的資料不應視為在任何國家/司法管轄區關於任何投資基金產品及服務的出售或作出認購招攬的要約，或對任何第三方的意見或建議。瀏覽本應用程式之人士在作出相關投資決策前，應考慮其自身的財務狀況、能承受風險的能力及建議尋求獨立第三方專業的投資意見。\n\n本應用程式所提供的全部資料均受版權保護。只有獲得華亞證券書面批准者方可使用，否則嚴禁改編、複製、分發或提供本應用程式所載的資料作商業或公開用途。\n\n若閣下使用超連結至其它網站或其它資料來源，當中風險概由閣下自行負責。華亞證券對可與本應用程式連接的網站所提供資訊、內容的準確性、合規性或適用性不會承擔任何責任，亦不會保障閣下對第三者所提供的資訊是受到保護的。\n\n閣下需注意本應用程式所提供的任何基金產品報價資料並非即時報價資訊，所有報價取決於當時市場情況，而相關條款可能作出變動並以最終的交易文件作準。該等報價並非反映有關投資基金產品真實的認購價或贖回價，所有價格均以基金公司最終作實為準。\n\n本應用程式所提供的基金投資產品資訊均以其銷售文件 ( 包括並不限於其條款概要、基金章程、資訊單張及所有其它相關銷售文件及材料 ) 所載之條款及規定約束。閣下在作出投資決策前必須仔細閱讀全部相關投資基金產品之銷售文件。任何經華亞證券出售或申請認購任何投資基金產品需接受華亞證券擁有最終決定權及均受華亞證券可不時更新之服務條款及任何其他國家/司法管轄區投資基金服務之條款及規定所約束。',

    zjmz1:'注意事項及免責聲明',
    zjmz2:'注意事項',
    zjmz3:'投資債券產品涉及重大風險，投資者可能無法取回 ( 部份或全部 ) 最初投資之金額。本聲明不可能完全披露涉及閣下所投資債券產品的相關風險。在作出投資決策前，閣下請詳細閱讀有關投資債券產品的銷售文件，確保完全瞭解有關投資債券產品的性質及其相關所泛及的風險，及願意承擔這類型風險，並建議向獨立第三方索取專業的投資意見。\n\n在決定投資有關債券產品前，閣下必須詳細考慮根據閣下的公民身份、居住地或戶籍的國家/司法管轄區 ( 或閣下所屬公司所註冊成立國家/司法管轄區 ) 或會與購買、銷售、認購、持有、轉換或出售相關債券投資產品內持股有關在法律下，閣下 ( 或閣下所屬公司 ) 可能需要面對的稅務、法律規定以及任何外匯管制規定所連帶之後果。\n\n投資債券的回報以其基本貨幣計算。如閣下所屬國家/司法管轄區貨幣與其投資債券的基本貨幣或參考貨幣不同，匯率變動或會使閣下的投資回報有所增加或減少。',
    zjmz4:'免責聲明',
    zjmz5:'本應用程式所刊載的債券投資產品並非適用於所有國家/司法管轄區。只有適用法律容許之人士，才可瀏覽此應用程式的資訊及/或接受本免責聲明所提及的服務及投資產品。瀏覽此免責聲明的人士，必須確保其知悉及遵守有關的適用限制，及自行負責查證其所在國家/司法管轄區的法律是否容許其瀏覽本應用程式及/或使用有關服務。本應用程式所提供的資訊目的在提供給香港特別行政區的居民使用及/或瀏覽。\n\n本應用程式的債券投資產品資訊謹供一般性參考及全部以「如原狀」情況所提供。華亞證券不會對該等資料作出任何保證，另華亞證券可在毋須事前通知的情況下，隨時更改該等資料。\n\n本應用程式所提供的資料不應視為在任何國家/司法管轄區關於任何投資債券產品及服務的出售或作出認購招攬的要約，或對任何第三方的意見或建議。瀏覽本應用程式之人士在作出相關投資決策前，應考慮其自身的財務狀況、能承受風險的能力及建議尋求獨立第三方專業的投資意見。\n\n本應用程式所提供的全部資料均受版權保護。只有獲得華亞證券書面批准者方可使用，否則嚴禁改編、複製、分發或提供本應用程式所載的資料作商業或公開用途。\n\n若閣下使用超連結至其它網站或其它資料來源，當中風險概由閣下自行負責。華亞證券對可與本應用程式連接的網站所提供資訊、內容的準確性、合規性或適用性不會承擔任何責任，亦不會保障閣下對第三者所提供的資訊是受到保護的。\n\n閣下需注意本應用程式所提供的任何債券產品報價資料並非即時報價資訊，所有報價取決於當時市場情況，而相關條款可能作出變動並以最終的交易文件作準。該等報價並非反映有關投資債券產品真實的認購價或贖回價，所有價格均以債券公司最終作實為準。\n\n本應用程式所提供的債券投資產品資訊均以其銷售文件 ( 包括並不限於其條款概要、債券章程、資訊單張及所有其它相關銷售文件及材料 ) 所載之條款及規定約束。閣下在作出投資決策前必須仔細閱讀全部相關投資債券產品之銷售文件。任何經華亞證券出售或申請認購任何投資債券產品需接受華亞證券擁有最終決定權及均受華亞證券可不時更新之服務條款及任何其他國家/司法管轄區投資債券服務之條款及規定所約束。',

    hide_1:'參考價格：',
    hide_2:'最低持倉額：',
    hide_3:'股息分派方式：',
    hide_4:'三年風險收益率：',
    hide_5:'近三個月回報：',
    hide_6:'入場費：',
    hide_7:'最低贖回額：',
    hide_8:'派息頻率：',
    hide_9:'夏普比率：',
    hide_10:'近一個月回報：',
    hide_11:'後續投資額：',
    hide_12:'複雜投資產品：',
    hide_13:'預計收益年率：',
    hide_14:'年初至今回報：',
    hide_15:'管理費：',
    hide_16:'認購時間：',
    hide_17:'證監會認可產品：',
    hide_18:'估值日期：',

    bond_1:'參考賣出價：',
    bond_2:'賣出到期收益率：',
    bond_3:'專業投資者：',
    bond_4:'發債機構：',
    bond_5:'參考買入價：',
    bond_6:'買入到期收益率：',
    bond_7:'複雜投資產品：',
    bond_8:'可否贖回：',
    bond_9:'入場費：',
    bond_10:'信貸評級：',
    bond_11:'發行日期：',
    bond_12:'估值日期：',
    bond_13:'票面值：',
    bond_14:'剩餘年期：',

    khmc_wq:'客戶名稱：',
    zhhm_wq:'帳戶號碼：',
    dlsj_wq:'最後一次登入：',
    
    wq_ts1:'在進行投資產品 ( 基金/債券 ) 交易前，華亞證券需評估閣下的投資取向與產品之相對合適性評級是否適合閣下進行認購。',
    wq_ts2:'本問卷合共9條問題，完成時間約需５分鐘',
    sign_off:'登出',

    turn_1:'請輸入證券帳號',
    turn_2:'請輸入電話號碼',
    turn_3:'證券類型',
    turn_4:'美國證券轉入',
    turn_5:'美國證券轉出',
    turn_6:'DTC證券轉入',
    turn_7:'驗證碼',
    turn_8:'請輸入驗證碼',
    turn_9:'證券轉倉',
    turn_10:'已提交',
    turn_11:'閣下的證券轉倉申請已提交成功。證券轉倉流程預計需要5-7個工作日完成，閣下亦需自行通知外部券商轉入/轉出證券股份。',
    turn_12:'請閣下不要通過轉出外部券商帳戶進行沽出交易，以避免因資產信息不一致而導致轉倉申請失敗。',
    turn_13:'請填寫下述「投資產品交收指示(美股)」辦理有關美國上市證券 / 投資產品存取手續 :-',
    turn_14:'投資產品交收指示(美股)',
    turn_15:'證券交易帳戶資料',
    turn_16:'帳戶號碼',
    turn_17:'請輸入帳戶號碼',
    turn_18:'客戶名稱',
    turn_19:'請輸入客戶名稱',
    turn_20:'帳戶類別',
    turn_21:'證券現金帳戶',
    turn_22:'日間聯絡電話號碼',
    turn_23:'請輸入日間聯絡電話號碼',
    turn_24:'交付方經紀人資料',
    turn_25:'申請日期',
    turn_26:'請選擇申請日期',
    turn_27:'要求交收日期',
    turn_28:'請選擇要求交收日期',
    turn_29:'交付方經紀人名稱',
    turn_30:'請輸入交付方經紀人名稱',
    turn_31:'交付方經紀人地址',
    turn_32:'請輸入交付方經紀人地址',
    turn_33:'清算系統編號',
    turn_34:'請輸入清算系統編號',
    turn_35:'交割日期',
    turn_36:'請選擇交割日期',
    turn_37:'聯絡人名稱',
    turn_38:'請輸入聯絡人名稱',
    turn_39:'聯絡人電話號碼',
    turn_40:'請輸入聯絡人電話號碼',
    turn_41:'客戶帳戶號碼',
    turn_42:'請輸入客戶帳戶號碼',
    turn_43:'客戶帳戶名稱',
    turn_44:'請輸入客戶帳戶名稱',
    turn_45:'收款 / 付款指示',
    turn_46:'證券編號',
    turn_47:'請輸入證券編號',
    turn_48:'證券名稱',
    turn_49:'請輸入證券名稱',
    turn_50:'股份數量',
    turn_51:'請輸入股份數量',
    turn_52:'付款指示',
    turn_53:'無需付款交收',
    turn_54:'貨銀對付交收',
    turn_55:'即時貨銀對付',
    turn_56:'請選擇其中一項',
    turn_57:'交收金額 (美元)',
    turn_58:'請輸入交收金額 (美元)',
    turn_59:'收費 (美元)',
    turn_60:'請輸入收費 (美元)',
    turn_61:'若客戶沒有作出付款指示選項，華亞證券將以「無需付款交收」執行有關交易。',
    turn_62:'*「交收指示」中所產生之全部費用，華亞證券將於客戶證券交易帳戶內扣除。',
    turn_63:'美國證券轉出資訊',
    turn_64:'DTC證券轉入申請資訊',
    turn_65:'請問閣下持有的DTC證券在市場上通過場外電子報價板 (OTCBB) 還是粉單市場 (Pink Sheets) 購買的？',
    turn_66:'請問閣下持有的DTC證券是否通過員工證券期權計劃 (ESOP) 所獲得的？',
    turn_67:'請問閣下存入DTC證券的目的是甚麼 ?',
    turn_68:'請輸入閣下存入DTC證券的目的',
    turn_69:'在過去一年內，閣下累計收取已發行或轉讓該DTC證券是多少 ?',
    turn_70:'請輸入閣下在過去一年內累計收取已發行或轉讓該DTC證券是多少',
    turn_71:'是',
    turn_72:'否',
    turn_73:'提 交',
    turn_74:'場外電子報價板',
    turn_75:'粉單市場',
   
}

export default lang;



// WEBPACK FOOTER //
// ./src/assets/big5.js